import { useState } from 'react';
import './Home.css';
import plot1 from '../../assets/plots/plot1.jpg';
import plot2 from '../../assets/plots/plot2.jpg';
import plot3 from '../../assets/plots/plot3.jpeg';
import plot4 from '../../assets/plots/plot4.jpeg';
import jrLogo from '../../assets/JR_logo.png';
import heroImg from '../../assets/hero-home-image.png';
import heroImg2 from '../../assets/hero-home-image2.png';

// Import images
import GetStartedSection from '../../components/GetStartedSection/GetStartedSection';
import ToolsSection from '../../components/ToolsSection/ToolsSection';
import CategorySection from '../../components/category/CategorySection';

const Home = () => {
    const [activeFaq, setActiveFaq] = useState<number | null>(0);
    const [activeSlide, setActiveSlide] = useState<number>(1);

    const toggleFaq = (index: number) => {
        setActiveFaq(activeFaq === index ? null : index);
    };

    return (
        <div className="home-page">

            {/* Hero Section */}
            <section className="hero" style={{ backgroundImage: `url(${heroImg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="overlay"></div>

                <div className="hero-content">
                    <p className="tagline">Jeevan Realty, Your Trusted Real Estate Agency</p>

                    <h1>
                        Jeevan Realty<br />
                        Your trusted partner for buying and selling properties in and around Coimbatore.
                    </h1>
                </div>
            </section>


            {/* HERO BOTTOM CONTENT */}
            <section className="hero-bottom">
                <div className="hero-bottom-container">

                    <h2 className="hero-bottom-title">
                        A Real Estate Agency in Coimbatore.<br />
                        Buy, Sell or Rent Property
                    </h2>

                    <p className="hero-bottom-text">
                        Jeevan Realty is a reliable real estate agency in Coimbatore, renowned for providing comprehensive, one-stop assistance for properties in and around the city.
                        We deliver highly effective and client-focused services, ensuring a smooth and transparent experience at every step.
                        As one of the few real estate agencies in Coimbatore with a well-maintained repository of property information and data, we help you make informed and confident decisions.

                    </p>

                    <p className="hero-bottom-text">
                        In today’s digitally connected world, we understand the importance of saving time. Our property listings feature complete details, high-resolution images, and layout plans,
                        enabling prospective buyers to evaluate properties easily and efficiently.
                    </p>

                </div>
            </section>


            {/* EXCLUSIVE projects */}
            <section className="exclusive-Property">

                {/* Section Header */}
                <div className="exclusive-header">
                    <span className="badge">Listed for You</span>
                    <h2 className="section-title">Exclusive Properties</h2>
                </div>

                {/* Property Cards */}
                <div className="exclusive-grid">

                    {/* Card 1 */}
                    <div className="project-card">
                        <img src={plot1} alt="Gem Field Kovilpalayam" />
                        <div className="project-info">
                            <h3>Gem Field Kovilpalayam</h3>
                            <p>Kovilpalayam</p>
                        </div>
                    </div>

                    {/* Card 2 */}
                    <div className="project-card">
                        <img src={plot4} alt="TRS Avenue" />
                        <div className="project-info">
                            <h3>TRS Avenue</h3>
                            <p>Kurumbapalayam, Sathy Road</p>
                        </div>
                    </div>

                    {/* Card 3 */}
                    <div className="project-card">
                        <img src={plot3} alt="Mass Grand Kurumbapalayam" />
                        <div className="project-info">
                            <h3>Mass Grand Kurumbapalayam</h3>
                            <p>Kurumbapalayam</p>
                        </div>
                    </div>

                    {/* Card 4 */}
                    <div className="project-card">
                        <img src={plot2} alt="Metro Grand" />
                        <div className="project-info">
                            <h3>Metro Grand</h3>
                            <p>Manikampalayam</p>
                        </div>
                    </div>

                </div>

            </section>



            {/* GET STARTED SECTION */}
            <GetStartedSection />

            {/* OUR SERVICES SECTION */}
            <section className="services-section">

                <div className="services-container">

                    {/* LEFT CONTENT */}
                    <div className="services-left">

                        <span className="services-badge">What you Get</span>

                        <h2 className="services-title">Our Services</h2>

                        <p className="services-description">
                            Discover a complete range of real estate solutions—from property buying and selling to investment guidance, marketing, management, and construction. Jeevan Realty
                            delivers expert support and seamless service for every step of your real estate journey.
                        </p>

                        {/* SERVICE LIST */}
                        <div className="services-list">

                            {/* ITEM 1 */}
                            <div className="service-item">
                                <div className="service-icon">🏠</div>
                                <span className="service-text">Buy & Sell Property</span>
                                <span className="service-arrow">→</span>
                            </div>

                            {/* ITEM 2 */}
                            <div className="service-item">
                                <div className="service-icon">📈</div>
                                <span className="service-text">Real Estate Investments</span>
                                <span className="service-arrow">→</span>
                            </div>

                            {/* ITEM 3 */}
                            <div className="service-item">
                                <div className="service-icon">🛠️</div>
                                <span className="service-text">Marketing & Management</span>
                                <span className="service-arrow">→</span>
                            </div>

                        </div>

                    </div>

                    {/* RIGHT IMAGE */}
                    <div className="services-right" style={{ backgroundImage: `linear-gradient(rgba(20, 38, 92, 0.15), rgba(20, 38, 92, 0.15)), url(${heroImg2})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        {/* background image goes via CSS */}
                    </div>

                </div>

            </section>





            {/* POTENTIAL property SECTION */}
            <section className="property-section">

                {/* Section Header */}
                <div className="property-header">
                    <span className="property-badge">Prime Picks for You</span>
                    <h2 className="property-title">Potential property</h2>
                </div>

                {/* property Grid */}
                <div className="exclusive-grid">

                    {/* CARD 1 */}
                    <div className="project-card">
                        <img src={plot1} alt="Jains Aashna Apartment" />
                        <div className="project-info">
                            <h3>2BHK Individual villa for sale near Tips Global, Kurumbapalayam</h3>
                            <p>Kurumbapalayam</p>
                        </div>
                    </div>

                    {/* CARD 2 */}
                    <div className="project-card">
                        <img src={plot2} alt="Jains Aashna Apartment" />
                        <div className="project-info">
                            <h3>Corner Plot for Sale in RP Dream Castle</h3>
                            <p>Ponnaegoundenpudur</p>
                        </div>
                    </div>

                    {/* CARD 3 */}
                    <div className="project-card">
                        <img src={plot3} alt="Crown City" />
                        <div className="project-info">
                            <h3>Residential plot for sale in Crown City</h3>
                            <p>Kovilpalayam, Coimbatore</p>
                        </div>
                    </div>

                    {/* CARD 4 */}
                    <div className="project-card">
                        <img src={plot4} alt="Individual Villa" />
                        <div className="project-info">
                            <h3>Individual villa for sale in Kovilpalayam, Sathy Road, Coimbatore</h3>
                            <p>Kovilpalayam, Coimbatore</p>
                        </div>
                    </div>

                </div>

            </section>



            {/* TOOLS LOGOS SECTION */}
            <ToolsSection />

            {/* vission section */}


            <section className="vision-section">

                <div className="vision-container">

                    {/* LEFT CONTENT */}
                    <div className="vision-left">



                        <h2 className="vision-title">
                            Where Vision Meets Realty<br />
                            Crafting Your Perfect property
                        </h2>

                        <p className="vision-author">Author</p>

                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="vision-right">

                        <div className="vision-stats">

                            <div className="stat-box">
                                <h3>100+</h3>
                                <p>Our Happy Customers</p>
                            </div>

                            <div className="stat-box">
                                <h3>98%</h3>
                                <p>Clients Satisfaction Rate</p>
                            </div>

                            <div className="stat-box">
                                <h3>150+</h3>
                                <p>Total Property Sale</p>
                            </div>

                            <div className="stat-box">
                                <h3>15+</h3>
                                <p>Years of Experience</p>
                            </div>

                        </div>

                    </div>

                </div>

            </section>



            <section className="clients-section">

                <div className="clients-container">

                    {/* LEFT CONTENT */}
                    <div className="clients-left">

                        <span className="clients-badge">Tales From The Real Estate</span>

                        <h2 className="clients-title">
                            Our Clients<br />
                            Feedback.
                        </h2>
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="clients-right">

                        <div className="feedback-grid">
                            {[
                                {
                                    rating: "★ ★ ★ ★ ★",
                                    text: "“Helped me with buying a plot that matched my requirements and budget. Followed up with me closely and ensured smooth transaction. Helped me to close the deal rightly before a price increase. Highly recommend Mr. Ganesh and team.”",
                                    name: "Rajinikanth Muthukrishnan",
                                    location: "Bangalore"
                                },
                                {
                                    rating: "★ ★ ★ ★ ☆",
                                    text: "“I have purchased first land with help of Jeevan Realty. They provided professionals service and always helpful. Responded all our queries and had to finish our registration work in a week time as I was traveling Overseas. The over all process was pretty smooth and excellent. Trustworthy.”",
                                    name: "Anju Donny",
                                    location: "Coimbatore"
                                }
                            ].map((fb, index) => (
                                <div key={index} className={`feedback-card ${activeSlide === index + 1 ? 'mobile-active' : ''}`}>
                                    <div className="rating">{fb.rating}</div>
                                    <p className="feedback-text">{fb.text}</p>
                                    <h4 className="client-name">{fb.name}</h4>
                                    <p className="client-location">{fb.location}</p>
                                </div>
                            ))}
                        </div>

                        {/* SLIDER CONTROLS */}
                        <div className="feedback-dots">
                            {[1, 2].map((num) => (
                                <label
                                    key={num}
                                    className={`dot ${activeSlide === num ? 'active' : ''}`}
                                    onClick={() => setActiveSlide(num)}
                                ></label>
                            ))}
                        </div>
                    </div>

                </div>

            </section >






            {/* WHATSAPP CHANNEL SECTION */}
            < section className="whatsapp-section" >
                <div className="whatsapp-container">

                    {/* LEFT TEXT */}
                    <div className="whatsapp-text">
                        <h2>
                            Join to our Whatsapp<br />
                            Channel to Always be in the<br />
                            Loop
                        </h2>
                    </div>

                    {/* RIGHT CARD */}
                    <div className="whatsapp-card">
                        <div className="wa-card-header">
                            <div className="wa-logo">
                                <img src={jrLogo} alt="Jeevan Realty" />
                            </div>
                        </div>

                        <div className="wa-card-content">
                            <h3>Jeevan Realty</h3>
                            <p>WhatsApp channel</p>

                            <div className="wa-qr-code">
                                <img src="https://placehold.co/200x200?text=QR+Code" alt="QR Code" />
                                <div className="wa-icon">
                                    <svg viewBox="0 0 24 24" width="30" height="30" fill="#25D366">
                                        <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.711 2.592 2.654-.696c1.005.572 1.903.87 3.05.87 3.19 0 5.775-2.587 5.775-5.766 0-1.545-.601-2.997-1.692-4.088a5.725 5.725 0 00-4.085-1.692h-.242zm.001 10.125c-1.025 0-1.928-.32-2.709-.796l-1.93.504.52-1.908c-.615-.96-.867-1.879-.867-2.977 0-2.614 2.127-4.742 4.742-4.742 1.266 0 2.457.493 3.352 1.388.895.895 1.388 2.086 1.388 3.352 0 2.614-2.126 4.742-4.741 4.742h-.001v.437z"></path>
                                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.18 12.18 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.064 2.875 1.212 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.408h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"></path>
                                    </svg>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </section >


            {/* CATEGORY SECTION */}
            < CategorySection />

            <section className="faq-section">

                {/* HEADER */}
                <div className="faq-header">
                    <h2>FAQ</h2>
                    <p>We Are Here To Help You With Any Questions You May Have</p>
                </div>

                {/* FAQ GRID */}
                <div className="faq-grid">

                    {/* LEFT COLUMN */}
                    <div className="faq-column">

                        {/* OPEN FAQ */}
                        <div className={`faq-item ${activeFaq === 0 ? 'active' : ''}`} onClick={() => toggleFaq(0)}>
                            <div className="faq-question">
                                <h4>How much time does it take to find a Property?</h4>
                                <span className="icon">{activeFaq === 0 ? '▲' : '▼'}</span>
                            </div>

                            <div className="faq-answer">
                                <p>
                                    Finding your dream property in and around Coimbatore with Jeevan Realty is a smooth and hassle-free experience. Based on your specific requirements, a curated list of suitable properties will be shared for shortlisting.
                                    The entire process is efficient and typically completed within just a couple of weeks.
                                </p>
                            </div>
                        </div>

                        {/* CLOSED FAQ */}
                        <div className={`faq-item ${activeFaq === 1 ? 'active' : ''}`} onClick={() => toggleFaq(1)}>
                            <div className="faq-question">
                                <h4>What is the right way to start this process?</h4>
                                <span className="icon">{activeFaq === 1 ? '▲' : '▼'}</span>
                            </div>
                            <div className="faq-answer">
                                <p>Scheduling an appointment with us is just a click away. Use our Whatsapp chat through our website to discuss with our executive right now!</p>
                            </div>
                        </div>

                        <div className={`faq-item ${activeFaq === 2 ? 'active' : ''}`} onClick={() => toggleFaq(2)}>
                            <div className="faq-question">
                                <h4>What are the documents required to purchase a property?</h4>
                                <span className="icon">{activeFaq === 2 ? '▲' : '▼'}</span>
                            </div>
                            <div className="faq-answer">
                                <p>Scheduling an appointment with us is just a click away. Use our Whatsapp chat through our website to discuss with our executive right now!</p>
                            </div>
                        </div>

                        <div className={`faq-item ${activeFaq === 7 ? 'active' : ''}`} onClick={() => toggleFaq(7)}>
                            <div className="faq-question">
                                <h4>Can you guarantee that you will find my next property?</h4>
                                <span className="icon">{activeFaq === 7 ? '▲' : '▼'}</span>
                            </div>
                            <div className="faq-answer">
                                <p>Our core function is all about delivering services as per your requirement and our full-fledged data base is our strength to assure you that we will be able to find what you need, and we are committed to fulfill the same.</p>
                            </div>
                        </div>

                    </div>

                    {/* RIGHT COLUMN */}
                    <div className="faq-column">

                        <div className={`faq-item ${activeFaq === 3 ? 'active' : ''}`} onClick={() => toggleFaq(3)}>
                            <div className="faq-question">
                                <h4>Can you help me find a Property outside Coimbatore?</h4>
                                <span className="icon">{activeFaq === 3 ? '▲' : '▼'}</span>
                            </div>
                            <div className="faq-answer">
                                <p>Yes, our band width expands to the other parts of Tamil Nadu as well.</p>
                            </div>
                        </div>

                        <div className={`faq-item ${activeFaq === 4 ? 'active' : ''}`} onClick={() => toggleFaq(4)}>
                            <div className="faq-question">
                                <h4>Can I be a part of the Jeevan Realty family?</h4>
                                <span className="icon">{activeFaq === 4 ? '▲' : '▼'}</span>
                            </div>
                            <div className="faq-answer">
                                <p>For sure, you can also be a part of Jeevan Realty. If you have a good network and thorough knowledge. Reach us on +91 95148 96744 to have a detailed chat.</p>
                            </div>
                        </div>

                        <div className={`faq-item ${activeFaq === 5 ? 'active' : ''}`} onClick={() => toggleFaq(5)}>
                            <div className="faq-question">
                                <h4>The must-do steps before buying/selling a property?</h4>
                                <span className="icon">{activeFaq === 5 ? '▲' : '▼'}</span>
                            </div>
                            <div className="faq-answer">
                                <p>Finding right and genuine realtor is the foremost important step, the other key pointers are:1. Financials 2. Thorough legal verification 3. Negotiation 4. Documentation 5. Adhering to government norms and policies</p>
                            </div>
                        </div>

                        <div className={`faq-item ${activeFaq === 6 ? 'active' : ''}`} onClick={() => toggleFaq(6)}>
                            <div className="faq-question">
                                <h4>Is The Agency Planning To Open More Offices?</h4>
                                <span className="icon">{activeFaq === 6 ? '▲' : '▼'}</span>
                            </div>
                            <div className="faq-answer">
                                <p>There is always a scope for expansion.</p>
                            </div>
                        </div>

                    </div>

                </div>

            </section>
        </div >
    );
};

export default Home;
